module.exports = Queries = {}

Queries.boardFieldsMinimal = [
  'name'
  'closed'
  'dateLastActivity'
  'dateLastView'
  'datePluginDisable'
  'idOrganization'
  'prefs'
  'shortLink'
  'shortUrl'
  'url'
  'creationMethod'
].join(',')

Queries.boardFieldsFull = [
  Queries.boardFieldsMinimal
  'desc'
  'descData'
  'idTags'
  'invitations'
  'invited'
  'labelNames'
  'limits'
  'memberships'
  'powerUps'
  'subscribed'
].join(',')

Queries.boardFieldsMinimalSubscribed = [
  Queries.boardFieldsMinimal
  'subscribed'
].join(',')

Queries.memberFields = [
  'avatarHash'
  'bio'
  'bioData'
  'confirmed'
  'fullName'
  'idEnterprise'
  'idMemberReferrer'
  'initials'
  'memberType'
  'nonPublic'
  'products'
  'url'
  'username'
].join(',')

Queries.memberFieldsStatus = [
  Queries.memberFields
  'status'
].join(',')

Queries.memberFieldsAndPremOrgsAdmin = [
  Queries.memberFields
  'idPremOrgsAdmin'
].join(',')

Queries.organizationFieldsMinimal = [
  'name'
  'displayName'
  'products'
  'prefs'
  'logoHash'
  'idEnterprise'
  'tags'
  'limits'
].join(',')

Queries.organizationFieldsMinimalMemberships = [
  Queries.organizationFieldsMinimal
  'memberships'
].join(',')

Queries.cardFieldsBulk = [
  'badges'
  'closed'
  'dateLastActivity'
  'desc'
  'descData'
  'due'
  'dueComplete'
  'dueReminder'
  'idAttachmentCover'
  'idList'
  'idBoard'
  'idMembers'
  'idShort'
  'idLabels'
  'limits'
  'name'
  'pos'
  'shortUrl'
  'shortLink'
  'subscribed'
  'url'
].join(',')

Queries.boardFieldsInOrganization = [
  Queries.boardFieldsMinimal
  'idTags'
].join(',')

Queries.organizationBoardsFields = [
  Queries.organizationFieldsMinimal
  'desc'
  'descData'
  'website'
  'limits'
  'billableCollaboratorCount'
].join(',')

Queries.cardActions = [
  'addAttachmentToCard'
  'addChecklistToCard'
  'addMemberToCard'
  'commentCard'
  'copyCommentCard'
  'convertToCardFromCheckItem'
  'createCard'
  'copyCard'
  'deleteAttachmentFromCard'
  'emailCard'
  'moveCardFromBoard'
  'moveCardToBoard'
  'removeChecklistFromCard'
  'removeMemberFromCard'
  'updateCard:idList'
  'updateCard:closed'
  'updateCard:due'
  'updateCard:dueComplete'
  'updateCheckItemStateOnCard'
  'updateCustomFieldItem'
].join(',')

Queries.boardActions = [
  Queries.cardActions
  'addMemberToBoard'
  'addToOrganizationBoard'
  'copyBoard'
  'createBoard'
  'createCustomField'
  'createList'
  'deleteCard'
  'deleteCustomField'
  'disablePlugin'
  'disablePowerUp'
  'enablePlugin'
  'enablePowerUp'
  'makeAdminOfBoard'
  'makeNormalMemberOfBoard'
  'makeObserverOfBoard'
  'moveListFromBoard'
  'moveListToBoard'
  'removeFromOrganizationBoard'
  'unconfirmedBoardInvitation'
  'unconfirmedOrganizationInvitation'
  'updateBoard'
  'updateCustomField'
  'updateList:closed'
].join(',')

Queries.card =
  fields: 'all'
  stickers: true
  attachments: true
  customFieldItems: true
  pluginData: true

Queries.currentBoardMinimal =
  lists: 'open'
  list_fields: 'name,closed,idBoard,pos,subscribed,limits,creationMethod,softLimit'
  cards: 'visible'
  card_attachments: 'cover'
  card_stickers: true
  card_fields: [Queries.cardFieldsBulk, 'labels'].join(',')
  card_checklists: 'none'
  members: 'all'
  member_fields: Queries.memberFieldsStatus
  membersInvited: 'all'
  membersInvited_fields: Queries.memberFields
  memberships_orgMemberType: true
  checklists: 'none'
  organization: true
  organization_fields: 'name,displayName,desc,descData,url,website,prefs,memberships,logoHash,products,limits,idEnterprise'
  organization_tags: true
  organization_enterprise: true
  myPrefs: true
  fields: Queries.boardFieldsFull

Queries.currentBoardSecondary =
  fields: ''
  actions: Queries.boardActions
  actions_display: true
  actions_limit: 50
  action_memberCreator_fields: Queries.memberFieldsAndPremOrgsAdmin
  action_reactions: true
  checklists: 'none'
  cards: 'visible'
  card_fields: ''
  card_checklists: 'all'
  card_checklist_checkItems: 'none'
  labels: 'all'
  labels_limit: 1000

Queries.currentBoardPluginData =
  fields: ''
  boardPlugins: true
  cards: 'visible'
  card_fields: ''
  card_attachments: true
  card_attachment_fields: 'bytes,date,edgeColor,idMember,isUpload,mimeType,name,url'
  card_customFieldItems: true
  customFields: true
  pluginData: true
  card_pluginData: true
  organization: true
  organization_fields: ''
  organization_pluginData: true

Queries.memberBoards =
  boards: 'open,starred'
  board_fields: Queries.boardFieldsMinimalSubscribed
  boardStars: true
  boardsInvited: 'all'
  boardsInvited_fields: Queries.boardFieldsMinimalSubscribed
  board_organization: true
  board_organization_fields: Queries.organizationFieldsMinimal
  credits: 'invitation,promoCode'
  organizations: 'all'
  organization_fields: Queries.organizationFieldsMinimalMemberships
  organizationsInvited: 'all'
  organizationsInvited_fields: Queries.organizationFieldsMinimal
  paid_account: true

Queries.memberHeader =
  channels: true
  organizations: 'all'
  organization_paid_account: true
  organization_fields: 'name,displayName,idEnterprise'
  organization_enterprise: true
  paid_account: true
  pluginData: true
  savedSearches: true
  missedTransferDate: true
  enterprises: true
  enterprise_filter: ['saml', 'member', 'member-unconfirmed', 'owned']
  enterprise_fields: 'name,displayName,isRealEnterprise,accessEnabled'

Queries.organizationBoardsPage =
  boards: 'open'
  board_fields: Queries.boardFieldsInOrganization
  board_starCounts: 'organization'
  board_membershipCounts: 'active'
  fields: Queries.organizationBoardsFields
  paid_account: true
  memberships: 'active'
  members: 'all'
  tags: true,
  billableCollaboratorCount: true

Queries.memberQuickBoards =
  fields: 'idOrganizations'
  boards: 'open,starred'
  board_fields: Queries.boardFieldsMinimal
  boardStars: true
  organizations: 'all'
  organization_fields: 'idBoards'

Queries.quickBoardsSearch = (search) ->
  query: search
  modelTypes: 'boards'
  board_fields: Queries.boardFieldsMinimal
  partial: true



// WEBPACK FOOTER //
// ./app/scripts/network/quick-queries.coffee